// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home .roll[data-v-75ea7c9e]{height:18.229vw;overflow-x:hidden;overflow-y:scroll;font-size:.677vw;color:#333;font-weight:400;text-align:left}.home .btn[data-v-75ea7c9e]{width:7.813vw;height:3.047vw;font-size:.625vw;margin:auto}", ""]);
// Exports
module.exports = exports;
